import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL     = process.env.REACT_APP_SUPABASE_URL
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    // Automatically detect session from URL hash (magic link callback)
    detectSessionInUrl: true,
    persistSession: true,
    autoRefreshToken: true,
  }
})
